import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { accessToken, refreshToken, userData } from "../redux/userDataSlice";
import { callApi } from "../api/apiCaller";
import { routes } from "../api/routes";
import Loader from "../components/loader/loader";
import { GreenNotify, RedNotify } from "../helper/helper";
import Dashboard from "../pages/dashboard/dashboard";
import Users from "../pages/userlist/Users";

import {
  employer,
  logOutIcon,
  mainIcon,
  offer,
  userIcon,
  UploadIcon,
} from "../assets";
import "./layout.css";
import Employer from "../pages/employer/employer";
import EmployerCard from "../pages/employerCard/EmployerCard";
import AboutUs from "../pages/aboutUs/AboutUs";
import AddEmployer from "../components/AddEmployer";
import EditEmployer from "../components/editEmployer/EditEmployer";
import EditUser from "../components/editUser/EditUser";
import EditEmployerCard from "../components/editEmployerCard/EditEmployerCard";
import AddEmployerCard from "../components/addEmployerCard/AddEmployerCard";
import Terms from "../pages/terms%conditions/Terms&Conditions";
import OfferEng from "../pages/offerEng/Offer";
import OfferArabic from "../pages/offerArabic/Offer";
import UploadEng from "../pages/uploadEng/Upload";
import UploadArabic from "../pages/uploadArabic/Upload";
import UploadBulkOffers from "../pages/uploadBulkOffers/Upload";
import NotificationSettings from "../pages/notificationSettings/NotificationSettings";
import LocalityCard from "../pages/loyalityCard/LoyalityCard";

const { Content, Sider } = Layout;

const LayoutDashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    setSelectedKeys(location.pathname);
  }, [location.pathname]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  const logOut = () => {
    const getRes = (res) => {
      if (res.status === 200) {
        GreenNotify(res.message);
        dispatch(userData(null));
        dispatch(accessToken(""));
        dispatch(refreshToken(""));
        navigate("/login");
      } else {
        RedNotify(res.message);
      }
    };

    const body = {
      device: {
        id: localStorage.getItem("deviceId"),
        deviceToken: "xyz",
      },
    };

    callApi("POST", routes.logOut, body, setIsLoading, getRes, (error) => {
      console.log("error", error);
    });
  };

  const handleMenuClick = ({ key }) => {
    if (key === "logOut") {
      logOut();
      closeSidebar();
      return;
    }

    setSelectedKeys(key);
    navigate(key);
    closeSidebar(); // Close sidebar on mobile after navigation
  };

  const menuItems = [
    {
      key: "/users",
      className: "menu-item",
      icon: <img className="menu-icon" src={userIcon} alt="Users" />,
      label: "Users",
    },
    {
      key: "/employer",
      className: "menu-item",
      icon: <img className="menu-icon" src={employer} alt="Employer" />,
      label: "Employer",
    },
    {
      key: "/loyaltyCard",
      className: "menu-item",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          width="24"
          height="24"
          x="0"
          y="0"
          viewBox="0 0 512.026 512.026"
          className="menu-icon-svg"
        >
          <g>
            <path
              d="m492.169 143.227 11.597-11.759a28.8 28.8 0 0 0 6.716-29.491 27.409 27.409 0 0 0-21.845-18.773l-55.859-8.439a10.3 10.3 0 0 1-7.68-5.973l-25.165-52.983a26.845 26.845 0 0 0-48.93 0L325.82 68.842a10.3 10.3 0 0 1-7.68 5.973l-55.859 8.439a27.407 27.407 0 0 0-21.845 18.773 28.8 28.8 0 0 0 6.716 29.491l5.009 5.12H42.667C19.114 136.667.028 155.753 0 179.306v290.039c.028 23.552 19.114 42.638 42.667 42.667h426.667c23.552-.028 42.638-19.114 42.667-42.667V179.212a42.397 42.397 0 0 0-19.832-35.985zm-235.52-35.84a10.291 10.291 0 0 1 8.201-7.262l55.851-8.439a27.349 27.349 0 0 0 20.54-15.497l25.173-53.043a9.805 9.805 0 0 1 18.108 0l25.173 53.043a27.351 27.351 0 0 0 20.531 15.497l55.859 8.439a10.293 10.293 0 0 1 8.201 7.262 11.855 11.855 0 0 1-2.671 12.092l-40.107 40.61a29.013 29.013 0 0 0-7.774 25.02l9.506 57.626a11.53 11.53 0 0 1-4.531 11.452 9.25 9.25 0 0 1-10.044.614l-50.483-27.588a26.454 26.454 0 0 0-25.429 0L312.32 254.8a9.251 9.251 0 0 1-10.044-.614 11.528 11.528 0 0 1-4.531-11.452l9.455-57.626a29.014 29.014 0 0 0-7.825-25.02l-40.055-40.61a11.853 11.853 0 0 1-2.671-12.117zM42.667 153.612h226.355l18.219 18.466a11.848 11.848 0 0 1 3.132 10.24l-9.506 57.626a28.484 28.484 0 0 0 11.503 28.16 26.368 26.368 0 0 0 28.1 1.707l50.466-27.588a9.385 9.385 0 0 1 9.062 0l50.466 27.588a26.35 26.35 0 0 0 28.1-1.707 28.484 28.484 0 0 0 11.503-28.16l-9.506-57.626a11.842 11.842 0 0 1 3.132-10.24l16-16.213a25.387 25.387 0 0 1 15.241 23.347v162.133H17.067V179.212c0-14.139 11.461-25.6 25.6-25.6zm452.266 273.067H17.067v-68.267h477.867v68.267zm-25.6 68.266H42.667c-14.138 0-25.6-11.462-25.6-25.6v-25.6h477.867v25.6c-.001 14.139-11.462 25.6-25.601 25.6z"
              fill="#ffffff"
              opacity="1"
            ></path>
            <path
              d="M375.467 298.679a8.533 8.533 0 0 0 8.533-8.533v-25.6a8.533 8.533 0 0 0-17.066 0v25.6a8.533 8.533 0 0 0 8.533 8.533zM375.467 332.812a8.533 8.533 0 0 0 8.533-8.533v-8.533a8.533 8.533 0 0 0-17.066 0v8.533a8.533 8.533 0 0 0 8.533 8.533zM409.6 315.745a8.533 8.533 0 0 0 8.533-8.533v-25.6a8.533 8.533 0 0 0-17.066 0v25.6a8.533 8.533 0 0 0 8.533 8.533zM341.333 315.745a8.533 8.533 0 0 0 8.533-8.533v-25.6a8.533 8.533 0 0 0-17.066 0v25.6a8.533 8.533 0 0 0 8.533 8.533zM76.8 290.145h85.333c14.138 0 25.6-11.462 25.6-25.6v-51.2c0-14.138-11.462-25.6-25.6-25.6H76.8c-14.138 0-25.6 11.462-25.6 25.6v51.2c0 14.139 11.462 25.6 25.6 25.6zm-8.533-76.8a8.533 8.533 0 0 1 8.533-8.533h85.333a8.533 8.533 0 0 1 8.533 8.533v51.2a8.533 8.533 0 0 1-8.533 8.533H76.8a8.533 8.533 0 0 1-8.533-8.533z"
              fill="#ffffff"
              opacity="1"
            ></path>
          </g>
        </svg>
      ),
      label: "Loyalty Card",
    },
    {
      key: "/offerEng",
      className: "menu-item",
      icon: <img className="menu-icon" src={offer} alt="Offers" />,
      label: "Offer (Eng)",
    },
    {
      key: "/offerArabic",
      className: "menu-item",
      icon: <img className="menu-icon" src={offer} alt="Offers" />,
      label: "Offer (Arabic)",
    },
    {
      key: "/uploadBulkOffers",
      className: "menu-item",
      icon: <img className="menu-icon" src={UploadIcon} alt="Bulk Upload" />,
      label: "Bulk Offer Upload",
    },
    {
      key: "/settings",
      className: "menu-item",
      icon: (
        <svg
          className="menu-icon-svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M15 17H5L6.5 15.5V11.5C6.5 9.01472 7.94772 7.12624 10 6.5V6C10 5.17157 10.6716 4.5 11.5 4.5C12.3284 4.5 13 5.17157 13 6V6.5C15.0523 7.12624 16.5 9.01472 16.5 11.5V15.5L18 17H15ZM11.5 19.5C10.67 19.5 10 18.83 10 18H13C13 18.83 12.33 19.5 11.5 19.5Z"
            fill="currentColor"
          />
        </svg>
      ),
      label: "Notifications",
    },
    {
      type: "divider",
      className: "menu-divider-item",
    },
    {
      key: "logOut",
      className: "menu-item logout-item",
      icon: (
        <img className="menu-icon logout-icon" src={logOutIcon} alt="Logout" />
      ),
      label: "Log Out",
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Loader loading={isLoading} />
      
      {/* Mobile Menu Button */}
      <button className={`mobile-menu-btn ${sidebarOpen ? 'hidden' : ''}`} onClick={toggleSidebar}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div className="mobile-overlay" onClick={closeSidebar}></div>
      )}

      <Sider className={`custom-sidebar ${sidebarOpen ? 'mobile-open' : ''}`} width={280}>
        {/* Mobile Close Button */}
        <button className="mobile-close-btn" onClick={closeSidebar}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        {/* Logo Section */}
        <div className="sidebar-logo-container" onClick={() => { navigate("/"); closeSidebar(); }}>
          <img src={mainIcon} alt="JAK Logo" className="sidebar-logo" />
          <h2 className="sidebar-brand-text">JAK Admin</h2>
        </div>

        {/* Navigation Menu */}
        <Menu
          className="sidebar-menu"
          theme="dark"
          mode="inline"
          onClick={handleMenuClick}
          selectedKeys={[selectedKeys]}
          items={menuItems}
        />
      </Sider>
      <Layout className="site-layout">
        <Content style={{ background: "#fff", paddingTop: "2rem" }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/editUser" element={<EditUser />} />
            <Route path="/employer" element={<Employer />} />
            <Route path="/employerCard" element={<EmployerCard />} />
            <Route path="/offerEng" element={<OfferEng />} />
            <Route path="/offerArabic" element={<OfferArabic />} />
            <Route path="/aboutUs" element={<AboutUs />} />
            <Route path="/addEmployer" element={<AddEmployer />} />
            <Route path="/editEmployer" element={<EditEmployer />} />
            <Route path="/uploadEng" element={<UploadEng />} />
            <Route path="/loyaltyCard" element={<LocalityCard />} />
            <Route path="/uploadArabic" element={<UploadArabic />} />
            <Route path="/uploadBulkOffers" element={<UploadBulkOffers />} />
            <Route path="/settings" element={<NotificationSettings />} />
            <Route path="/editEmployerCard" element={<EditEmployerCard />} />
            <Route path="/addEmployerCard" element={<AddEmployerCard />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutDashboard;
